export function getBaseUrl(): string {
    if (!process.env.NEXT_PUBLIC_URL) {
        return process.env.NEXT_PUBLIC_VERCEL_URL ?? '';
    }

    return process.env.NEXT_PUBLIC_URL;
}
